/**
 * Created by sagardesai on 25/06/18.
 */

export const checkIfFollowingListAvailable = (props) => {
    return (
        props.hasOwnProperty("following") &&
        props.following.hasOwnProperty("followingList") &&
        props.following.followingList &&
        props.following.followingList !== null  &&
        props.following.followingList.data.hasOwnProperty("data") &&
        props.following.followingList.data.data !== null
    )
}